import { Text } from '@chakra-ui/react';
import { useCallback, useMemo, useState } from 'react';
import {
  Dropdown,
  DropdownButton,
  DropdownContent,
  DropdownItem,
} from 'ui-components';

import { useAddContentStore } from '../useAddContentStore';
import { sortByList } from './constants';
import { SortByListType, SortByType } from './types';

const getSortByList = (platforms: string) => {
  if (platforms.length > 0 && platforms.split(',').length === 1) {
    const platform = platforms.split(',');
    return sortByList[platform[0] as keyof typeof sortByList];
  }

  return sortByList['default'];
};

export const SortBy = () => {
  const [isOpen, setIsOpen] = useState(false);

  const { platforms, sortBy, setSortBy } = useAddContentStore();

  const list = getSortByList(platforms);

  const selectedSortBy = useMemo(() => {
    const item = list.find((s) => s.value === sortBy);
    return item;
  }, [list, sortBy]) as SortByListType;

  const handleSortByClick = useCallback(() => {
    setIsOpen(!isOpen);
  }, [isOpen, setIsOpen]);

  const handleSelectSortBy = useCallback(
    (value: SortByType) => {
      setSortBy(value);
    },
    [setSortBy],
  );

  return (
    <Dropdown isOpen={isOpen}>
      <DropdownButton size="md" onClick={handleSortByClick}>
        <Text color="primary.400" fontWeight={400}>
          Sort by:
        </Text>
        <Text color="primary.700">
          {selectedSortBy
            ? selectedSortBy.friendlyValue
            : 'Select a sort option'}
        </Text>
      </DropdownButton>
      <DropdownContent>
        {list.map((item) => (
          <DropdownItem
            key={item.value}
            onClick={() => handleSelectSortBy(item.value)}
          >
            {item.friendlyValue}
          </DropdownItem>
        ))}
      </DropdownContent>
    </Dropdown>
  );
};
